<template>
  <div class="copyright">
    © Copyright - Stéphanie Lefebvre - 2020
  </div>
</template>

<script>
  export default {
    name: 'AppCopyright'
  }
</script>

<style lang="scss" scoped>

  .copyright {
    z-index: 1;
    background: $color-green;
    width: 100%;
    text-align: center;
    color: #fff;
    padding: .5em;
    font-size: .8em;
  }

</style>
